import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  // paginação vagas efetivas
  const itemsPerPage = 3;
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );
  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "naturadiadasmaes",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      <nav className="bg-[#2175D9] h-24">
        <div className="flex items-center justify-between p-4 pr-[10%] relative max-[768px]:justify-center">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Randstad Logo"
              className="h-26"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li className="pr-[10%]">
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center">
        <div
          id="main-title"
          className="flex flex-col items-center z-10 w-[70%] max-[1024px]:hidden"
        >
          <p className="text-white text-6xl font-graphik mr-[10%] max-[768px]:text-xl tracking-tighter">
            trabalho e bem estar
          </p>
          <p className="text-white text-6xl font-graphik ml-[20%] max-[768px]:text-xl tracking-tighter">
            andando lado a lado
          </p>
        </div>
        <div className="w-[30%] max-[1024px]:hidden mr-24">
          <img
            src="./assets/images/banner-04.png"
            alt="Dia das Mães Natura Landing Page"
            className="w-full"
          />
        </div>
        <div className="w-full md:hidden">
          <p className="text-white mt-12 font-graphik flex items-center justify-center max-[768px]:text-4xl text-center tracking-tighter">
            trabalho e bem estar
          </p>
          <p className="text-white font-graphik items-center flex justify-center pt-2 max-[768px]:text-4xl text-center tracking-tighter">
            andando lado a lado
          </p>
          <img
            src="./assets/images/banner-04.png"
            alt="Dia das Mães Natura Landing Page"
            className="w-full"
          />
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 mt-12 px-[7vw] max-[768px]:flex-col !pt-0"
        id="parceria"
      >
        <div className="flex flex-col pt-4 w-1/2 max-[768px]:w-full">
          <h1 className="text-4xl font-regular text-blue-500 mb-8">
            Parceria Natura e Randstad
          </h1>
          <p className="text-lg text-black mb-2 font-light">
            A Natura, em parceria com a Randstad, líder global em recrutamento e
            soluções completas de recursos humanos, presente em mais de 39
            países pelo mundo, uniu forças para garantir um processo seletivo
            que, além de selecionar talentos, também apresente como é trabalhar
            em uma renomada empresa de cosméticos e produtos de beleza. A Natura
            é reconhecida por seu compromisso com a sustentabilidade e o uso de
            ingredientes naturais da biodiversidade amazônica. Seu portfólio
            abrange diversas categorias, incluindo cuidados com a pele,
            oferecendo hidratantes, protetores solares e produtos anti-idade;
            perfumaria, maquiagem, linha completa para cabelos, além de produtos
            para cuidados pessoais, como sabonetes, óleos corporais,
            desodorantes e cremes para mãos e pés.
          </p>
        </div>
        <div className="w-1/2 h-auto max-[768px]:hidden">
          <img
            src="./assets/images/banner-02.png"
            alt="Dia das Mães Natura"
            className="w-full"
          />
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 pl-[7vw] max-[768px]:flex-col !pt-0"
        id="sobre"
      >
        <div className="w-1/3 h-auto max-[768px]:hidden">
          <img
            src="./assets/images/banner-03.png"
            alt="Dia das Mães Natura"
            className="w-full"
          />
        </div>
        <div className="flex flex-col pt-4 w-1/2 max-[768px]:w-full max-[768px]:pr-8">
          <h1 className="text-4xl font-regular text-blue-500 mb-8">
            Sobre a Natura
          </h1>
          <p className="text-lg text-black mb-2 font-light">
            Fundada em 1969, a Natura é uma marca brasileira que nasceu da
            paixão pela cosmética e pelas relações. Estão presentes em sete
            países da América Latina, além de França, Estados Unidos e Malásia.
            A rede conta com 6,9 mil colaboradores e 2 milhões de consultoras e
            consultores Natura, além de fornecedores e parceiros. Acreditam na
            inovação como um dos pilares para gerar impacto positivo e alcançar
            um modelo de desenvolvimento sustentável. Buscam criar valor para a
            sociedade como um todo, gerando resultados integrados nas dimensões
            social, econômica e ambiental.
          </p>

          <a href="#oportunidades" className="w-[350px]">
            <button className="bg-[#2074D9] text-white w-full h-[60px] rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              clique aqui e confira nossas vagas
            </button>
          </a>
        </div>
      </div>

      <div
        className="flex w-full gap-6 pl-[7vw] pr-[9vw] max-[768px]:flex-col !pt-0"
        id="sobre"
      >
        <div className="flex flex-col w-full max-[768px]:w-full">
          <h1 className="text-3xl font-regular text-blue-500 mb-4">
            A missão da Natura no Brasil
          </h1>
          <p className="text-lg text-black mb-6 font-light">
             A Natura tem como missão criar e comercializar produtos e serviços
            que promovam o bem-estar, proporcionando harmonia das pessoas
            consigo mesmas, com os outros e com a natureza. A empresa busca
            impactar positivamente a sociedade e o meio ambiente por meio de um
            modelo de negócio sustentável. Sua visão é ser uma marca global,
            reconhecida por sua capacidade de inovar e gerar impacto positivo na
            sociedade e no meio ambiente. A empresa busca fortalecer seu modelo
            de negócios sustentável, ampliando sua presença e influência no
            setor de cosméticos e beleza.
          </p>
          <p className="text-lg text-black mb-6 font-light">
            A Natura se baseia em valores como a valorização das relações, a
            transparência, a inovação, a sustentabilidade e o compromisso com a
            sociedade. A empresa acredita na importância de construir conexões
            genuínas, respeitar a diversidade e atuar de maneira ética e
            responsável para gerar um impacto positivo no mundo.
          </p>
        </div>
      </div>

      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-3xl font-graphik text-blue-500 mb-4 max-[768px]:text-2xl">
          quer uma oportunidade? Então faça sua inscrição!
        </h1>
        <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
          <select
            onChange={onChangeFilterJobsCity}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>
        {showLoader && (
          <div className="w-[90%] flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 font-light">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list !justify-center">
            <h2 className="text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <div>
          <p className="text-black text-2xl mb-8 ">
            Buscando dicas para a sua carreira? Confira nosso blog
          </p>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition max-[768px]:hidden"
            rel="noreferrer"
          >
            acesse nosso blog
          </a>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            rel="noreferrer"
            className="md:hidden"
          >
            <button className="text-blue-500 border-1 border-[#2074D9] w-full h-[60px] hover:text-white rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              acesse nosso blog
            </button>
          </a>
        </div>
      </div>

      <footer className="bg-[#2074D9] text-white pt-4">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="md:text-left mb-4 md:mb-0">
            <p>
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p className="mb-4">
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso Aviso de Privacidade.
            </p>
          </div>

          <div className="flex space-x-4 pb-8">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
